import React, { useState, useEffect, useRef, useMemo } from "react";
import { connect, useDispatch, useSelector } from "react-redux";
import _, { isEmpty, get, cloneDeep } from "lodash";
import ToastModal from "../../../../../components/ToastModal";
import TableCustom from "../../../../../components/CustomTable";
import { Button, Table } from "antd";
import asyncRoute from "../../../../../helpers/hoc/asyncRoute";
import routes from "../../../../../routes";
import { Modal } from "semantic-ui-react";
import { getDataConfigListAction } from "../../../../../actions";
import { postDataConfigDetailsAction } from "../../../../../actions/dataConfig";
import { withRouter } from "react-router-dom";
import { attributeOptions } from "./constant";
import { isApiCallSuccess } from "../../../../../selectors";
import "../../DataConfig.scss";
import { checkTablePermission } from "../../../../../utils/route-auth";
import { PERMISSION } from "../../../../../constants/permission";

const BreadCrumb = asyncRoute(() =>
  import("../../../../../components/BreadCrumb")
);
const Card = asyncRoute(() => import("../../../../../components/Card"));
const Tabs = asyncRoute(() => import("../../../../../components/Tabs"));

const List = (props) => {
  const tenantId = useSelector((state) =>
    get(state, "app.preSignInState.tenantId", "")
  );
  const userId = useSelector((state) =>
    get(state, "app.preSignInData.userId", "")
  );
  const authToken = useSelector((state) =>
    get(state, "app.signInData.authToken", "")
  );
  const dispatch = useDispatch();

  const [variableListAllData, setVariableListAllData] = useState([]);
  const [toastModal, setToastModal] = useState({
    enableToast: false,
    toastStatus: "",
    toastMsg: "",
  });

  const options = useMemo(() => {
    return (
      checkTablePermission({ edit: PERMISSION.ADMIN.DATACONFIG.EDIT }, {
        columns: [
          { id: -1, name: "", label: "", sortable: false },
          {
            id: 1,
            name: "s.no",
            label: "S.No.",
            sortable: false,
            type: "number",
            expand: true,
          },
          {
            id: 2,
            name: "platformName",
            label: "Platform",
            sortable: true,
            type: "string",
            component: (row) => {
              return (
                <div className="d-flex flex-column">
                  <span>{row.platformName ? row.platformName : ""}</span>
                  {row.mappedPlatformsValueSet &&
                    row.mappedPlatformsValueSet.length > 0 && (
                      <span style={{ color: "#5e66e9", fontSize: 13 }}>
                        +{row.mappedPlatformsValueSet.length}
                      </span>
                    )}
                </div>
              );
            },
          },
          {
            id: 3,
            name: "name",
            label: "Variable Name",
            sortable: true,
            type: "string",
          },
          {
            id: 4,
            name: "displayName",
            label: "Variable Display Text",
            sortable: true,
            type: "string",
            component: (row) => (row.displayName ? row.displayName : ""),
          },
          {
            id: 5,
            name: "list",
            label: "Primary Values",
            sortable: false,
            type: "number",
            component: (row) => {
              let rowData = row.list.length > 4 ? row.list.slice(0, 3) : row.list;
              return (
                <div>
                  {row.list.length > 4 ? (
                    <>
                      {rowData.map((variable) => {
                        return <p>{variable.name}</p>;
                      })}
                      <a
                        href="javascript:void(0)"
                        className="text-primary"
                        onClick={() => handleExpanded(row)}
                      >
                        More...
                        <i class="mdi mdi-menu-down"></i>
                      </a>
                    </>
                  ) : (
                    rowData.map((variable) => {
                      return <p>{variable.name}</p>;
                    })
                  )}
                </div>
              );
            },
          },
          {
            id: 6,
            name: "mapping",
            label: "Mapping",
            sortable: false,
            type: "string",
            component: (row) => {
              return (
                <div>
                  {row.mappedPlatformsValueSet &&
                    row.mappedPlatformsValueSet.length > 0 && (
                      <Button
                        onClick={() => {
                          getMappingDetails(row);
                        }}
                      >
                        Show Mapping
                      </Button>
                    )}
                </div>
              );
            },
          },
        ],
        actions: [
          {
            type: "edit",
            text: "",
            icon: "mdi mdi-pencil",
            tooltip: "Edit",
          },
        ],
        actionsThead: true,
        sortable: true,
        dateType: true,
        defaultSortParams: {},
        paging: true,
        defaultPagingParams: {
          pageSize: 25,
        },
      })
    )
  }, []);

  // const [options, setOptions] = useState({
  //   columns: [
  //     { id: -1, name: "", label: "", sortable: false },
  //     {
  //       id: 1,
  //       name: "s.no",
  //       label: "S.No.",
  //       sortable: false,
  //       type: "number",
  //       expand: true,
  //     },
  //     {
  //       id: 2,
  //       name: "platformName",
  //       label: "Platform",
  //       sortable: true,
  //       type: "string",
  //       component: (row) => {
  //         return (
  //           <div className="d-flex flex-column">
  //             <span>{row.platformName ? row.platformName : ""}</span>
  //             {row.mappedPlatformsValueSet &&
  //               row.mappedPlatformsValueSet.length > 0 && (
  //                 <span style={{ color: "#5e66e9", fontSize: 13 }}>
  //                   +{row.mappedPlatformsValueSet.length}
  //                 </span>
  //               )}
  //           </div>
  //         );
  //       },
  //     },
  //     {
  //       id: 3,
  //       name: "name",
  //       label: "Variable Name",
  //       sortable: true,
  //       type: "string",
  //     },
  //     {
  //       id: 4,
  //       name: "displayName",
  //       label: "Variable Display Text",
  //       sortable: true,
  //       type: "string",
  //       component: (row) => (row.displayName ? row.displayName : ""),
  //     },
  //     {
  //       id: 5,
  //       name: "list",
  //       label: "Primary Values",
  //       sortable: false,
  //       type: "number",
  //       component: (row) => {
  //         let rowData = row.list.length > 4 ? row.list.slice(0, 3) : row.list;
  //         return (
  //           <div>
  //             {row.list.length > 4 ? (
  //               <>
  //                 {rowData.map((variable) => {
  //                   return <p>{variable.name}</p>;
  //                 })}
  //                 <a
  //                   href="javascript:void(0)"
  //                   className="text-primary"
  //                   onClick={() => handleExpanded(row)}
  //                 >
  //                   More...
  //                   <i class="mdi mdi-menu-down"></i>
  //                 </a>
  //               </>
  //             ) : (
  //               rowData.map((variable) => {
  //                 return <p>{variable.name}</p>;
  //               })
  //             )}
  //           </div>
  //         );
  //       },
  //     },
  //     {
  //       id: 6,
  //       name: "mapping",
  //       label: "Mapping",
  //       sortable: false,
  //       type: "string",
  //       component: (row) => {
  //         return (
  //           <div>
  //             {row.mappedPlatformsValueSet &&
  //               row.mappedPlatformsValueSet.length > 0 && (
  //                 <Button
  //                   onClick={() => {
  //                     getMappingDetails(row);
  //                   }}
  //                 >
  //                   Show Mapping
  //                 </Button>
  //               )}
  //           </div>
  //         );
  //       },
  //     },
  //   ],
  //   actions: [
  //     {
  //       type: "edit",
  //       text: "",
  //       icon: "mdi mdi-pencil",
  //       tooltip: "Edit",
  //     },
  //   ],
  //   actionsThead: true,
  //   sortable: true,
  //   dateType: true,
  //   defaultSortParams: {},
  //   paging: true,
  //   defaultPagingParams: {
  //     pageSize: 25,
  //   },
  // });

  const [mappingColumns, setMappingColumns] = useState([
    {
      title: "Sr",
      dataIndex: "index",
      key: "index",
      width: 30,
    },
    {
      title: "Value Display Text",
      dataIndex: "name",
      key: "name",
      width: 150,
      align: "center",
      children: [
        {
          title: "Beki",
          dataIndex: "beki",
          key: "beki",
          width: 150,
        },
      ],
    },
    {
      title: "Mapped Value Display Text on Platforms",
      align: "center",
      key: "displayText",
      children: [],
    },
  ]);

  const [mappingData, setMappingData] = useState([]);

  const [attributeListModal, setAttributeListModal] = useState(false);
  const [mappedValueModal, setMappedValueModal] = useState(false);
  const [attributeList, setAttributeList] = useState([]);

  useEffect(() => {
    initializeList();
  }, []);

  const initializeList = async () => {
    await getDataConfigList();
  };

  const toast = (status, msg, type) => {
    setToastModal({
      enableToast: true,
      toastStatus: status,
      toastMsg: msg,
    });
    return;
  };

  const handleToastStatus = async (status) => {
    setToastModal({
      ...toastModal,
      enableToast: status,
    });
  };

  const confirmationCallbackModel = (id) => {
    setToastModal({
      ...toastModal,
      enableToast: false,
    });
  };

  const handleExpanded = (row) => {
    let attributeData = [row];
    setAttributeList(attributeData);
    setAttributeListModal(true);
  };

  const getMappingDetails = async (row) => {
    if (row.mappedPlatformsValueSet && row.mappedPlatformsValueSet.length > 0) {
      const params = { list: "mappingTable" };
      dispatch(
        postDataConfigDetailsAction({
          tenantId,
          authToken,
          userId,
          params,
          payload: { var: row },
        })
      ).then((responseData) => {
        const {
          responseCode: { status = "" },
          responseObj,
        } = responseData;
        if (isApiCallSuccess(status)) {
          let clonedColumnMaping = cloneDeep(mappingColumns);
          const platformColumns = row.mappedPlatformsValueSet.map(
            (data, inx) => {
              return {
                title: data,
                dataIndex: data,
                key: data,
                width: 150,
                render: (record) => <>{record ? record.join(", ") : ""}</>,
              };
            }
          );
          clonedColumnMaping.forEach((data, index) => {
            if (data.key == "displayText") {
              data.children = platformColumns;
            }
          });
          let arrayForMappingData = [];
          let count = 1;
          if (
            responseObj.mappedValues &&
            responseObj.mappedValues.beki &&
            responseObj.mappedValues.beki.length > 0
          ) {
            responseObj.mappedValues.beki.forEach((data) => {
              let tempObj = {
                beki: data.name,
              };
              if (data.mappingDetails && data.mappingDetails.length > 0) {
                data.mappingDetails.forEach((dataMap) => {
                  if (!tempObj[dataMap.platformName]) {
                    tempObj[dataMap.platformName] = [];
                  }
                  if (tempObj[dataMap.platformName]) {
                    tempObj[dataMap.platformName].push(dataMap.name);
                  }
                  // tempObj[dataMap.platformName] = dataMap.name
                });
              }
              tempObj["index"] = count;
              arrayForMappingData.push(tempObj);
              count++;
            });
          }

          if (responseObj.unmappedValues && responseObj.unmappedValues) {
            Object.keys(responseObj.unmappedValues).forEach((data) => {
              responseObj.unmappedValues[data].forEach((unMapData) => {
                let tempObj = {
                  beki: "",
                  index: count,
                };
                tempObj[unMapData.platformName] = [unMapData.name];
                arrayForMappingData.push(tempObj);
                count++;
              });
            });
          }

          //   console.log(arrayForMappingData);
          //   return;

          setMappingData(arrayForMappingData);
          setMappingColumns(clonedColumnMaping);
          setMappedValueModal(true);
        }
      });
    }
  };

  const getDataConfigList = async () => {
    let params = { list: "all", clubSimilarValues: true };
    await dispatch(
      getDataConfigListAction({ tenantId, authToken, userId, params })
    )
      .then((data) => {
        const {
          responseCode: { status = "" },
          response,
        } = data;
        if (status === "Success" && response && response.length > 0) {
          let modifiedResponse = response.map((item) => {
            return {
              ...item,
            };
          });
          setVariableListAllData(modifiedResponse);
        } else {
          console.log("Data config list not found");
        }
      })
      .catch((error) => {
        console.error(error);
      });
  };

  const handelAction = (row, action) => {
    const { match, history } = props;
    if (action.type == "edit") {
      history.push(
        `${match.path}/${routes.dataConfig.variables.editVariables}/${row.id}`
      );
    }
  };

  return (
    <>
      {toastModal.enableToast && (
        <ToastModal
          enableToast={toastModal.enableToast}
          status={toastModal.toastStatus}
          msg={toastModal.toastMsg}
          // path={routes.containers.admin + '/' + routes.admin.account.name}
          idProps={props}
          handleConfirmation={confirmationCallbackModel}
          handleToastStatus={handleToastStatus}
          confirmationMsg={toastModal.toastMsg}
          poc={true}
          outSideClickEnable={false}
        />
      )}

      <Modal open={mappedValueModal} size="large" className="modal-center-adj">
        <div className="modal-content" style={{ boxShadow: "unset" }}>
          <div className="modal-header">
            <h5
              className="modal-title"
              style={{ margin: "0 auto", color: "#040B1B" }}
            >
              Mapped Values
            </h5>
            <button
              type="button"
              onClick={() => {
                setMappedValueModal(false);
                setMappingData([]);
              }}
              className="close"
              data-dismiss="modal"
              aria-label="Close"
            >
              <div className="modal-title modal-colse modal-cross">
                <i class="menu-icon tf-icons ti ti-x"></i>
              </div>
            </button>
          </div>
          <Modal.Content scrolling>
            <div className="modal-body form__style">
              <div className="table-responsive dataConfig-adj">
                <Table
                  columns={mappingColumns}
                  dataSource={mappingData}
                  bordered
                  size="middle"
                />
              </div>
            </div>
          </Modal.Content>
        </div>
      </Modal>
      <Modal
        open={attributeListModal}
        size="small"
        className="modal-center-adj"
      >
        <div className="modal-content" style={{ boxShadow: "unset" }}>
          <div className="modal-header">
            <h5
              className="modal-title"
              style={{ margin: "0 auto", color: "#040B1B" }}
            >
              {attributeList[0] ? attributeList[0].name : ""}
            </h5>
            <button
              type="button"
              onClick={() => {
                setAttributeListModal(false);
              }}
              className="close"
              data-dismiss="modal"
              aria-label="Close"
            >
              <div className="modal-title modal-colse modal-cross">
                {/* <span aria-hidden="true">x</span> */}
                <i class="menu-icon tf-icons ti ti-x"></i>
              </div>
            </button>
          </div>
          <Modal.Content scrolling>
            <div className="modal-body form__style">
              <div className="table-responsive">
                <TableCustom
                  options={attributeOptions}
                  data={attributeList}
                // handelAction={this.handelAction}
                />
              </div>
            </div>
          </Modal.Content>
        </div>
      </Modal>

      <div className="main-panel ion">
        <div className="content-wrapper">
          <BreadCrumb />
          <div className="row mt-3">
            <Card>
              <Tabs container="admin" noButton={true} />
              <div className="pl-2 pt-3">
                <Tabs container="dataConfig" />
              </div>
              <div className="campaign-list-adj table-responsive">
                <TableCustom
                  options={options}
                  data={variableListAllData}
                  handelAction={handelAction}
                />
              </div>
            </Card>
          </div>
        </div>
      </div>
    </>
  );
};

export default withRouter(List);
